<div *ngIf="show$ | async" class="div-table-row">
	<div class="div-table-cell">
		<span class="align-left left-value">{{config.label}}</span>
		<p *ngIf="isMissingValue" class="align-left missing-icon">
			(<span><workflow-missing-value-icon></workflow-missing-value-icon></span>)
		</p>
	</div>
	<div class="div-table-cell">
		<span>:</span>
	</div>
	<div class="div-table-cell">
		<span [ngClass]="{ 'mx-2': alignTextLeft }" class="right-value">{{text$ | async}}</span>
	</div>
</div>
